<style scoped>
.btn-submit {
  background-color: #b03236;
  color: white;
}

.no-error-visible {
  display: none;
}

#actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

#actions a,
#actions button {
  margin: 5px;
}
</style>

<template lang="pug">
    form(@submit='submitForm' novalidate)
      div.collapsible-header.active
        i.material-icons info_outline
        | Details
      .row
        .col.s12#actions
          a.btn.indigo.right(@click='approve', v-if='isApplicant || isDisabled')
            | Enable
            i.material-icons.right check
          a.btn.red.right(@click='disable', v-if='isApproved')
            | Disable
            i.material-icons.right visibility_off
          a.btn.blue-grey.lighten-1.right(@click='readOnly = false', v-if='readOnly')
            | Edit
            i.material-icons.right edit
          button.btn.indigo.right(type='submit', v-else)
            | {{ supplier.new ? 'Save' : 'Update' }}
            i.material-icons.right save
      .row
        .col.s12.m6.input-field
          input#name(
            type='text', 
            placeholder='ex. inom ph',
            name='name', 
            :disabled='readOnly',
            @keyup='autogenerateCode',
            v-model='mutableSupplier.name',
            @focusout='validations.name.validate = true' 
            v-validate='validations.name')
          label.active(
            for='name', 
            data-error='Please provide a Supplier Name') Name *
          span.helper-text.red-text(v-if='validations.name.validate') {{errors.first('name')}}
        .col.s12.m6.input-field
          input#code(
            type='text',
            name='code', 
            v-model='mutableSupplier.code', 
            :disabled='readOnly',
            data-vv-delay='1000'
            v-validate='validations.code')
          label.active(
            for='name', 
            data-error='A web identifier must be 1-255 alphanumeric characters (period are allowed)') Web identifier *
          span.helper-text(v-if='!readOnly') 1-255 Alphanumeric characters ((may contain period, underscore, or dash)
          span.helper-text.red-text(v-if='validations.code.validate') {{errors.first('code')}}

      .row
        .col.s12.m6.input-field
          input#email(
            type='email', 
            placeholder='ex. name@domain.com' 
            name='email', 
            v-model='mutableSupplier.email', 
            :disabled='readOnly',
            @focusout='validations.email.validate = true',
            v-validate='validations.email')
          label.active(
            for='email',
            data-error='Please provide a valid email address') Email *
          span.helper-text.red-text(v-if='validations.email.validate') {{errors.first('email')}}
        .col.s12.m6.input-field
          input#contactNumber(
            type='text'
            placeholder='ex. +639991112233' 
            name='contactNumber'
            v-model='mutableSupplier.contactNumber'
            :disabled='readOnly'
            @focusout='validations.contactNumber.validate = true'
            v-validate='validations.contactNumber')
          label.active(
            for='contactNumber') Contact Number
          span.helper-text 639XXXXXXXXX format
          span.helper-text.red-text(v-if='validations.contactNumber.validate') {{errors.first('contactNumber')}}
      .row
        .col.s12.input-field
          input#address(
            type='text',
            placeholder='ex. Makati City',
            name='address', 
            v-model='mutableSupplier.address',
            :disabled='readOnly',
            @focusout='validations.address.validate = true',
            v-validate='validations.address')
          label.active(
            for='address') Address *
          span.helper-text.red-text(v-if='validations.address.validate') {{errors.first('address')}}
      .row
        .col.s12.input-field
          textarea#description.materialize-textarea(
            name='description'
            v-model='mutableSupplier.description', 
            :disabled='readOnly',
            @focusout='validations.description.validate = true'
            v-validate='validations.description')
          label.active(for='description') Description
          span.helper-text.red-text(v-if='validations.description.validate') {{errors.first('description')}}
</template>
<script>
import axios from "axios";
import xtend from "xtend";

export default {
  props: ["supplier", "index"],
  data() {
    return {
      validations: {
        name: {
          validate: false,
          required: true,
          min: 1,
          max: 255,
          regex: /^.*[a-zA-Z]+.*$/
        },
        code: {
          validate: false,
          required: true,
          regex: /^[a-zA-Z._-]+$/,
          uniqueCode: true,
          min: 1,
          max: 255
        },
        email: {
          validate: false,
          required: true,
          email: true
        },
        contactNumber: {
          validate: false,
          required: true,
          regex: /^639\d{9}$/
        },
        address: {
          validate: false,
          required: true,
          regex: /^.*[a-zA-Z]+.*$/,
          min: 6,
          max: 255
        },
        description: {
          validate: false,
          max: 255
        }
      },
      readOnly: this.supplier.new !== true,
      mutableSupplier: {
        id: this.supplier.id,
        code: this.supplier.code,
        name: this.supplier.name,
        email: this.supplier.email,
        contactNumber: this.supplier.contactNumber,
        address: this.supplier.address,
        description: this.supplier.description
      }
    };
  },
  created() {
    this.$validator.extend(
      "uniqueCode",
      {
        getMessage: field => "The identifier is already taken.",
        validate: this.checkCodeAvailability
      },
      {
        immediate: false
      }
    );
  },
  computed: {
    isApplicant() {
      return this.supplier.status === "application";
    },
    isApproved() {
      return this.supplier.status === "approved";
    },
    isDisabled() {
      return this.supplier.status === "disabled";
    }
  },
  methods: {
    checkCodeAvailability(code) {
      this.validations.code.validate = true;

      if (!code) {
        return Promise.resolve(true);
      }

      return this.$store.dispatch("auth/getAccessToken").then(accessToken => {
        return this.$http
          .get(`${this.$config.API_URL}/admin/suppliers/code/${code}`, {
            headers: {
              authorization: `Bearer ${accessToken}`
            }
          })
          .then(result => {
            return (
              result.data.id === null ||
              result.data.id === this.mutableSupplier.id
            );
          });
      });
    },
    autogenerateCode() {
      this.mutableSupplier.code = this.mutableSupplier.name
        ? this.mutableSupplier.name
            .toLowerCase()
            .trim()
            .replace(/\s\s*/g, ".")
        : null;
    },
    submitForm(e) {
      e.preventDefault();

      Object.keys(this.validations).forEach(key => {
        this.validations[key].validate = true;
      });

      this.$validator.validate().then(isValid => {
        if (!isValid) {
          return;
        }

        this.validateName = true;
        this.validateEmail = true;
        this.validateContactNumber = true;
        this.validateAddress = true;
        this.validateDescription = true;

        this.$store.dispatch("auth/getAccessToken", {}).then(accessToken => {
          if (this.supplier.new) {
            this.create(accessToken);
          } else {
            this.update(accessToken);
          }
        });
      });
    },
    create(accessToken) {
      axios
        .post(
          `${this.$config.API_URL}/admin/suppliers/`,
          this.mutableSupplier,
          {
            headers: {
              Authorization: "Bearer " + accessToken
            }
          }
        )
        .then(result => {
          this.$set(
            this,
            "mutableSupplier",
            xtend(this.mutableSupplier, result.data)
          );
          this.$emit("created", this.mutableSupplier);
          this.readOnly = true;
          this.$snackbar.show({
            text: "Supplier created"
          });
        });
    },
    update(accessToken) {
      axios
        .put(
          `${this.$config.API_URL}/suppliers/${this.supplier.code}`,
          this.mutableSupplier,
          {
            headers: {
              Authorization: "Bearer " + accessToken
            }
          }
        )
        .then(result => {
          this.$set(
            this,
            "mutableSupplier",
            xtend(this.mutableSupplier, result.data)
          );
          this.$emit("updated", xtend(this.supplier, this.mutableSupplier));
          this.readOnly = true;
          this.$snackbar.show({
            text: "Supplier details updated"
          });
        });
    },
    approve() {
      this.$store.dispatch("auth/getAccessToken").then(accessToken => {
        axios
          .post(
            `${this.$config.API_URL}/admin/suppliers/${
              this.supplier.id
            }/approve`,
            null,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            }
          )
          .then(result => {
            this.$set(
              this,
              "mutableSupplier",
              xtend(this.mutableSupplier, result.data)
            );
            this.$emit("updated", xtend(this.supplier, this.mutableSupplier));
            this.$snackbar.show({
              text: "Supplier enabled"
            });
          });
      });
    },
    disable() {
      this.$store.dispatch("auth/getAccessToken").then(accessToken => {
        axios
          .post(
            `${this.$config.API_URL}/admin/suppliers/${
              this.supplier.id
            }/disable`,
            null,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`
              }
            }
          )
          .then(result => {
            this.$set(
              this,
              "mutableSupplier",
              xtend(this.mutableSupplier, result.data)
            );
            this.$emit("updated", xtend(this.supplier, this.mutableSupplier));
            this.$snackbar.show({
              text: "Supplier disabled"
            });
          });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/app-supplier-details.vue